export const appConfig = {
    domain: process.env.VUE_APP_DOMAIN ?? 'http://localhost:3030',
    //domain: 'http://176.114.77.132:3030',
    //domain: 'https://послевыписки.рф:3031',

}